var _path, _mask, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 8.6L11.5 3L19.5 8.6V17.4C19.5 17.8243 19.3127 18.2313 18.9793 18.5314C18.6459 18.8314 18.1937 19 17.7222 19H5.27778C4.80628 19 4.3541 18.8314 4.0207 18.5314C3.6873 18.2313 3.5 17.8243 3.5 17.4V8.6Z",
    stroke: "current",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_2216_28822",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.85 19.2109V12.2109H12.15V19.2109"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44998 19.2109C9.44998 19.9841 10.0768 20.6109 10.85 20.6109C11.6232 20.6109 12.25 19.9841 12.25 19.2109H9.44998ZM10.85 12.2109V10.8109C10.0768 10.8109 9.44998 11.4377 9.44998 12.2109H10.85ZM12.15 12.2109H13.55C13.55 11.4377 12.9232 10.8109 12.15 10.8109V12.2109ZM10.75 19.2109C10.75 19.9841 11.3768 20.6109 12.15 20.6109C12.9232 20.6109 13.55 19.9841 13.55 19.2109H10.75ZM12.25 19.2109V12.2109H9.44998V19.2109H12.25ZM10.85 13.6109H12.15V10.8109H10.85V13.6109ZM10.75 12.2109V19.2109H13.55V12.2109H10.75Z",
    fill: "current",
    mask: "url(#path-2-inside-1_2216_28822)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.dcfa5c62be856940148043e448dbf5f3.svg";
export { ForwardRef as ReactComponent };